import React from 'react';
import { useDroppable } from '@dnd-kit/core';

const DroppableColumn = ({ id, children, style, statusColor }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: id, 
  });


  const activeStyle = {
    ...style,
    backgroundColor: isOver ? `${statusColor}15` : "transparent", 
    transition: 'all 0.2s ease',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px' ,    
    height : "700px",
    overflowY : "auto", 
    overflowX : "hidden",
  };

  return (
    <div ref={setNodeRef} style={activeStyle} className="columna-scroll">
      {children}
    </div>
  );
};

export default DroppableColumn;